export default "__VITE_ASSET__DMy$znYq__"